function transferDataToPost({ batchId, transactions }) {
  if (!batchId || !Array.isArray(transactions)) {
    return null;
  }

  const challengesNum = {};

  transactions.forEach(tran => {
    if (tran.metadata && tran.metadata.challenge_id) {
      if (!challengesNum[tran.metadata.challenge_id]) {
        challengesNum[tran.metadata.challenge_id] = 0;
      }
      challengesNum[tran.metadata.challenge_id] += 1;
    }
  });

  const challenges = [];

  Object.keys(challengesNum).forEach(id => {
    challenges.push({
      id,
      quantity: challengesNum[id]
    });
  });

  return {
    transfer_id: batchId,
    challenges
  };
}

export default transferDataToPost;
